<template>
  <Dialog
    :title="dialogTitle"
    show-close-button
    :q-card-props="{
      class: '!w-full !tablet:max-w-75vw tablet:max-h-75vh p-5',
    }"
  >
    <template #body>
      <div class="w-full flex justify-evenly gap-2 flex-col">
        <div
          class="w-full max-h-80vh tablet:max-h-60vh min-h-450px overflow-auto"
        >
          <div class="ul--normal" v-html="alert?.body" />
        </div>
        <div v-if="alert?.acknowledgedDate">
          {{ acknowledgedOn }}
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import type { SystemAlertsSystemAlertDetailsForUser } from 'client'
import { fullDate } from '~/helpers/date'

const p = defineProps<{ alert: SystemAlertsSystemAlertDetailsForUser | null }>()

const dialogTitle = computed(() => {
  return `System Alert: ${p.alert?.title ?? 'No Alert Title'}`
})

const acknowledgedOn = computed(() => {
  const ackDate = fullDate(p.alert?.acknowledgedDate)

  const viewCopy = p.alert?.requireAcknowledgement ? 'Acknowledged' : 'Viewed'

  return `${viewCopy} on: ${ackDate}`
})
</script>
